import React, { useState, useEffect } from "react"
import myInitObject from "../ultis/variable"
import ButtonStyled from "./styles/ButtonStyles"
import linkedinAuthoreIcon from "../../static/linkedin_authore.png"

const ManagingItem = ({ data }) => {
  const [activePerson, setActivePerson] = useState(false)

  const id = typeof window !== `undefined` ? window.location.hash : ""
  const name = data.value.name.replace(/ .*/, "")
  const urlName = id.substring(1)

  useEffect(() => {
    if (name === urlName) {
      setActivePerson(true)
      setTimeout(() => {
        scrollTo(document.querySelector("[data-name=" + urlName + "]"))
      }, 100)
    }
  })

  function changeActivePerson() {
    setActivePerson(!activePerson)
  }

  function scrollTo(element) {
    window.scroll({
      behavior: "smooth",
      left: 0,
      top: element.offsetTop - 100,
    })
  }

  return (
    <div
      data-name={name}
      className={`managing__item ${activePerson ? "active" : null}`}
    >
      <div className="managing__header">
        <p className="managing__name">
          {data.value.name}
          <span>{data.value.position}</span>
          <span className="managing__email">{data.value.email}</span>
          <span className="managing__linkedin">
            {" "}
            {data.value.linkedinUrl ? (
              <a href={data.value.linkedinUrl} target="_blank">
                <img src={linkedinAuthoreIcon} alt="linkedin" />
              </a>
            ) : (
              ""
            )}
          </span>
        </p>
        <img
          className="managing__img"
          src={myInitObject.cockpitUrl + data.value.image.path}
          alt={data.value.name}
        />
      </div>
      <div className="managing__body">
        {activePerson ? (
          <div
            className="managing__body__full"
            dangerouslySetInnerHTML={{
              __html: data.value.descriptionFull,
            }}
          ></div>
        ) : (
          <div
            className="managing__body__small"
            dangerouslySetInnerHTML={{
              __html: data.value.description,
            }}
          ></div>
        )}
      </div>
      <div className="managing__footer">
        <ButtonStyled dark={true}>
          <a
            onClick={() => {
              changeActivePerson()
            }}
          >
            {activePerson
              ? data.value.buttonTextLess
              : data.value.buttonTextMore}
          </a>
        </ButtonStyled>
      </div>
    </div>
  )
}

export default ManagingItem
